// extracted by mini-css-extract-plugin
module.exports = {"staking":"Staking_staking__1g6Xq"};